var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"above-panel",class:{
    'has-overhang': _vm.hasOverhang,
    'has-content': _vm.isOpen,
    'has-scrolled-sibling': _vm.hasScrollbar,
    'is-compact': _vm.isCompact,
  },attrs:{"tag":"aside","elevation":_vm.isAtTop ? 0 : 4}},[_c('portal-target',{ref:"above-panel-content",staticClass:"above-panel__content",attrs:{"name":"app-above-panel","multiple":"","tag":"div","transition":_vm.transitionComponent,"slot-props":{ isCompact: _vm.isCompact, isOpen: _vm.isOpen, hasScrollbar: _vm.hasScrollbar }},on:{"change":function($event){_vm.isOpen = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }